import { BlobReader, ZipReader } from "@zip.js/zip.js";

export async function zipFileEntries(file: File, filenameEncoding = "utf-8") {
  if (!file.name.toLowerCase().endsWith(".zip")) {
    throw new Error(`File "${file.name}" does not seem to be a ZIP file.`);
  }

  const blobReader = new BlobReader(file);
  const zipReader = new ZipReader(blobReader);

  return zipReader.getEntries({ filenameEncoding });
}
